@value mobile: 576px;
@value tablet: 768px;
@value laptop: 1024px;
@value desktop: 1280px;
@value wide: 1440px;
